function createListenersMap({ initialValues, }) {
    return {
        state: { listeners: new Set(), prevValue: initialValues?.state },
        status: { listeners: new Set(), prevValue: initialValues?.state?.status },
        user: { listeners: new Set(), prevValue: initialValues?.user },
        accessTokenData: { listeners: new Set(), prevValue: initialValues?.accessTokenData },
    };
}
/** Creates an object that manages subscriptions to the authenticator events (state/data changes) */
export function createEventEmitter({ initialValues }) {
    const listenersMap = createListenersMap({ initialValues });
    return {
        trigger: (event, value, equal = Object.is) => {
            // Call listeners only if the value has changed
            const { prevValue } = listenersMap[event];
            if (!equal(value, prevValue)) {
                Array.from(listenersMap[event].listeners).forEach((fn) => fn(value, prevValue));
                listenersMap[event].prevValue = value;
            }
        },
        subscribe: (event, listener) => {
            listenersMap[event].listeners.add(listener);
        },
        unsubscribe: (event, listener) => {
            listenersMap[event].listeners.delete(listener);
        },
        unsubscribeAll: () => {
            for (const event in listenersMap) {
                listenersMap[event].listeners.clear();
            }
        },
    };
}
